import React, { useContext } from 'react'
import Dialog from '@mui/material/Dialog'
import { DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

//components
import BottomButton from 'components/common/BottomButton'
import TimeLimitModal from './components/TimeLimitModal'
import IneligibleBalanceModal from './components/IneligibleBalanceModal'
//contexts
import AuthContext from 'context/AuthContext'
//styles
import './index.css'
//types
import { AuthContextType, ConfirmOrderModalProps } from 'types'

const ConfirmOrderModal = ({
  showModal,
  hideModal,
  giftCardName = '',
  denomination,
  piggyBanksValue,
  formattedPiggiesValue,
  timeLimit,
  handleOrderConfirm,
}: ConfirmOrderModalProps) => {
  const { user } = useContext(AuthContext) as AuthContextType

  if (user && piggyBanksValue > user.piggyBanks) {
    return <IneligibleBalanceModal showModal={showModal} hideModal={hideModal} />
  }
  if (timeLimit && timeLimit > Date.now()) {
    return <TimeLimitModal showModal={showModal} hideModal={hideModal} />
  }

  return (
    <Dialog open={showModal} onClose={hideModal} sx={styles.modal} maxWidth="xs">
      <DialogTitle variant="h1" sx={styles.title}>
        Confirm your order
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" className="confirmOrderModalText">
          Are you sure you want to purchase the ${denomination} USD {giftCardName} Gift Card for{' '}
          <span className="priceText pig">{formattedPiggiesValue}</span>{' '}
          <img src="/images/pig.png" /> ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <BottomButton handleClick={hideModal} style={styles.closeButton}>
          Close
        </BottomButton>
        <BottomButton handleClick={handleOrderConfirm}>Confirm</BottomButton>
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  modal: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      margin: '21px',
    },
  },
  title: {
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
  closeButton: {
    border: '2px solid rgb(251, 146, 60)',
    backgroundColor: '#ffffff',
    color: '#000000',
  },
  centeredButton: {
    width: '55%',
    margin: '0 auto',
    display: 'block',
  },
}

export default ConfirmOrderModal
